import {
  retrieveReportsRoleAssignments,
  retrieveRoleAssignmentReportRoles,
} from "@/lib/data/requests/reports/reports-role-assignments";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsRoleAssignmentsQueryOptions = (roleId: string) => ({
  queryKey: [queryKeys.reports, "role-assignments", roleId],
  queryFn: () => retrieveReportsRoleAssignments(roleId),
  enabled: Boolean(roleId),
});

export const retrieveRoleAssignmentReportRolesQueryOptions = () => ({
  queryKey: [queryKeys.reports, "role-assignments", "roles"],
  queryFn: retrieveRoleAssignmentReportRoles,
});
